import { gqlClient } from '@/utilities/graphQLClient';
import { gql } from '@/utilities/gql';
import type { QueryFunctionContext } from '@tanstack/react-query';

import { PUBLIC_PORTFOLIO_FRAGMENT } from '../usePortfolio';

type QueryContext = QueryFunctionContext<[string, string]>;

export const queryFn = async ({ queryKey: [_, id] }: QueryContext) => {
  const response = await gqlClient.request(
    gql(`
      query getDemoPortfolio($id: String!) {
        samplePortfolio(id: $id) {
          ...portfolioFields
        }
      }
      ${PUBLIC_PORTFOLIO_FRAGMENT}
    `),
    { id }
  );

  if ('samplePortfolio' in response) {
    return response.samplePortfolio;
  }
};
